const MODULE_ID = 'messaging';
export default MODULE_ID;
